(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["main-product"]) return;
  try {
    
    $('.panel__toggle').on('click', function() {
        var panelContent = $(this).next('.panel__content');
        panelContent.slideToggle();
        $(this).toggleClass('active-panel-toggle');
    })

  } catch(e) { console.error(e); }
})();

})();
